import { render, staticRenderFns } from "./QueryMessaggio.vue?vue&type=template&id=75f64d86&scoped=true&"
import script from "./QueryMessaggio.vue?vue&type=script&lang=js&"
export * from "./QueryMessaggio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f64d86",
  null
  
)

export default component.exports